/**
 * Phone numbers, formatted as they are typed — D-031: "(000) 000-0000".
 *
 * Pure and forgiving: digits are what count. An 11-digit number starting with
 * 1 (a pasted +1…) drops the country code; anything past ten digits is cut,
 * because the format IS the field's shape. Deleting works naturally — the
 * caller re-formats whatever remains.
 */
export function formatPhone(raw: string): string {
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  digits = digits.slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
